import { Box, Typography, useMediaQuery } from '@material-ui/core';
import {
  AGENT_TOOLBAR_CONTAINER_PADDING,
  CONTACT_AND_HEADER_TIGHT_WIDTH,
  CONTACT_AND_HEADER_WIDTH,
  CONTACT_SIDE_MENU_CONTAINER_RIGHT_PADDING,
  LAYOUT_PADDING_WIDTH,
  TRAYS_WIDTH,
} from '@src/components/AgentConsole/Layout/Utils';

import CustomAvatar from '@src/components/Common/CustomAvatar';
import { appConfig } from '@src/config/appConfig';
import { RootState } from '@src/store/reduxstore';
import React from 'react';
import { useSelector } from 'react-redux';
import OwnerAssignSelector from './OwnerAssignSelector';

const CONTACT_AVATAR_WIDTH = 64;
const EXTRA_PADDING = 16;

interface ContactInfoProps {
  fullName: string;
  avatarUrl: string;
  contactId: number;
  agentToolbarWidth: number;
}

const ContactInfo: React.FC<ContactInfoProps> = ({
  fullName,
  avatarUrl,
  contactId,
  agentToolbarWidth,
}) => {
  const isMaxWidth = useMediaQuery(
    `(max-width:${appConfig.maxWidthConsole}px)`
  );
  const isContextMenuOpened = useSelector(
    (state: RootState) => state.agentConsole.chatContextMenu.isOpened
  );

  const CURRENT_CONTACT_AND_HEADER_WIDHT =
    !isContextMenuOpened || isMaxWidth
      ? CONTACT_AND_HEADER_TIGHT_WIDTH
      : CONTACT_AND_HEADER_WIDTH;

  const WIDTH =
    TRAYS_WIDTH +
    CURRENT_CONTACT_AND_HEADER_WIDHT +
    LAYOUT_PADDING_WIDTH * 2 +
    AGENT_TOOLBAR_CONTAINER_PADDING * 2 +
    CONTACT_SIDE_MENU_CONTAINER_RIGHT_PADDING +
    CONTACT_AVATAR_WIDTH +
    EXTRA_PADDING +
    agentToolbarWidth;

  return (
    <Box display="flex" alignItems="center" data-testid="contact-info">
      <CustomAvatar
        avatarSrc={avatarUrl}
        username={fullName}
        type="invert"
        size="lg"
      />

      <Box display="flex" flexDirection="column" pl={1.5} minWidth={0}>
        <Typography
          color="textPrimary"
          style={{
            fontSize: '18px',
            fontWeight: 600,
            fontFamily: 'Poppins',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            width: `calc(100vw - ${WIDTH}px)`,
          }}
        >
          {fullName}
        </Typography>
        <Typography
          color="textPrimary"
          style={{
            fontSize: '12px',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            width: 195,
          }}
        >
          <Box display="flex">
            <OwnerAssignSelector
              contactId={`${contactId}`}
              key={`${contactId}`}
            />
          </Box>
        </Typography>
      </Box>
    </Box>
  );
};

export default ContactInfo;
